module.exports = __webpack_public_path__ + "static/media/listaIcon.6b073605.svg";